import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c218ed3e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "avatar-box"
};
var _hoisted_2 = {
  "class": "form-box"
};
var _hoisted_3 = {
  "class": "emoji-box"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "icon"
  }, null, -1);
});

var _hoisted_5 = ["disabled"];
var _hoisted_6 = {
  "class": "text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_mavon_editor = _resolveComponent("mavon-editor");

  var _component_EmojiSelector = _resolveComponent("EmojiSelector");

  var _component_el_progress = _resolveComponent("el-progress");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    "class": _normalizeClass("".concat($options.className, " comment-form"))
  }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    "class": _normalizeClass(["rich-input", {
      focus: $data.focus || $data.value
    }])
  }, [_createVNode(_component_mavon_editor, {
    language: $data.language,
    onImgAdd: $options.imgAdd,
    ref: "md",
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.value = $event;
    }),
    toolbars: $data.toolbars,
    defaultOpen: "edit",
    toolbarsFlag: false,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.focus = true;
    })
  }, null, 8, ["language", "onImgAdd", "modelValue", "toolbars"])], 2), _withDirectives(_createElementVNode("div", {
    "class": "option-box",
    onMousedown: _cache[5] || (_cache[5] = _withModifiers(function ($event) {
      return $options.closeEmojiSelector();
    }, ["prevent"]))
  }, [_createElementVNode("div", {
    "class": "emoji emoji-btn",
    onMousedown: _cache[3] || (_cache[3] = _withModifiers(function () {
      return $options.openEmojiSelector && $options.openEmojiSelector.apply($options, arguments);
    }, ["prevent", "stop"]))
  }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.emoj")), 1)]), _withDirectives(_createVNode(_component_EmojiSelector, {
    onChoose: _cache[2] || (_cache[2] = function (v) {
      return $data.value += v;
    })
  }, null, 512), [[_vShow, $data.showEmojiSelector]])], 32), _renderSlot(_ctx.$slots, "submitBtn", {}, function () {
    return [_createElementVNode("button", {
      "class": "submit-btn",
      disabled: !$data.value,
      onClick: _cache[4] || (_cache[4] = _withModifiers(function () {
        return $options.handleSubmit && $options.handleSubmit.apply($options, arguments);
      }, ["stop"]))
    }, _toDisplayString(_ctx.$t("label.reply")), 9, _hoisted_5)];
  }, true)], 544), [[_vShow, $data.focus || $data.value || $data.imgSrc]])])], 2), _createVNode(_component_el_dialog, {
    title: _ctx.$t('label.uploadImageProgress'),
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.dialogVisible = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_progress, {
        type: "circle",
        percentage: $data.uploadPercentage,
        status: $data.uploadPercentage === 100 ? 'success' : undefined
      }, null, 8, ["percentage", "status"])])];
    }),
    _: 1
  }, 8, ["title", "modelValue"])], 64);
}